import { ReportsModuleBox } from './component.styles'
export default ReportsModuleBox
